module.exports = __webpack_public_path__ + "static/media/home_background.de86a876.jpg";